import React from "react";
import {TableRow} from "@mui/material";
import {Svg} from "assets";
import {ButtonMain} from "../buttons";

export const NotYet = ({notTitleText = '',EmptySvg, notDescText = '', buttonText, clickToAddButton = () =>{}, styles = {}}) => {
    return (
        <TableRow className='table-empty-wrapper' style={{...styles, height: styles?.height ? `calc(${styles?.height} - 79px)` : ''}}>
            <div className="table-empty-box">
                {EmptySvg &&
                    <EmptySvg className="table-empty-svg"/>
                }
                {notTitleText &&
                    <p className="table-empty-title">{notTitleText}</p>
                }
                {notDescText &&
                    <p className="table-empty-desc">
                        {notDescText}
                    </p>
                }
                {buttonText && (
                    <ButtonMain
                        text={buttonText}
                        startIcon={<Svg.PlusSvg/>}
                        onClick={clickToAddButton}
                        small
                        buttonMainStyles={{
                            width: "fit-content",
                            padding: "6px 12px",
                        }}
                    />
                )}
            </div>
        </TableRow>
    );
};
